"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleRecordField = void 0;
const market_rule_base_1 = require("./market-rule-base");
class MarketRuleRecordField extends market_rule_base_1.MarketRuleBase {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.field = obj.field;
        }
    }
}
exports.MarketRuleRecordField = MarketRuleRecordField;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtcmVjb3JkLWZpZWxkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbnRlbnQvaGlzdG9yaWNhbC1wcmljaW5nL3RpbWUtc2VyaWVzL3NlcnZpY2VzL3J1bGUtZW5naW5lLXNlcnZpY2UvY2xhc3Nlcy9tYXJrZXQtcnVsZS1yZWNvcmQtZmllbGQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEseURBQW9EO0FBRXBELE1BQXNCLHFCQUFzQixTQUFRLGlDQUFjO0lBRzlEOzs7T0FHRztJQUNILFlBQW1CLEdBQW9DO1FBQ25ELEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUVYLElBQUksR0FBRyxFQUFFLENBQUM7WUFDTixJQUFJLENBQUMsS0FBSyxHQUFHLEdBQUcsQ0FBQyxLQUFNLENBQUM7UUFDNUIsQ0FBQztJQUNMLENBQUM7Q0FHSjtBQWhCRCxzREFnQkMifQ==